import Base from './base'
import urls from 'config/urls'

class Question extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.question.find,
      data: opts
    })
  }

  get (opts) {
    return this.httpGet({
      url: urls.question.get,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.question.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.question.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.question.delete,
      data: opts
    })
  }

  findCategory (opts) {
    return this.httpGet({
      url: urls.question.findCategory,
      data: opts
    })
  }

  createCategory (opts) {
    return this.httpPost({
      url: urls.question.createCategory,
      data: opts
    })
  }

  updateCategory (opts) {
    return this.httpPost({
      url: urls.question.updateCategory,
      data: opts
    })
  }

  deleteCategory (opts) {
    return this.httpPost({
      url: urls.question.deleteCategory,
      data: opts
    })
  }

  findForTestPaper (opts) {
    return this.httpGet({
      url: urls.question.findForTestPaper,
      data: opts
    })
  }
}

export default new Question



// WEBPACK FOOTER //
// ./src/models/question.js